import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CreateIcon from '@mui/icons-material/Create';

function createData(no, email, role, acction) {
  return { no, email, role, acction };
}

const rows = [
  createData(1, 'aaa@xmail.com', 'Admin', <CreateIcon fontSize="small" />),
  createData(2, 'bbb@xmail.com', 'Admin', <CreateIcon fontSize="small" />),
  createData(3, 'ccc@xmail.com', 'Admin', <CreateIcon fontSize="small" />),
  createData(4, 'ddd@xmail.com', 'Admin', <CreateIcon fontSize="small" />),
  createData(5, 'eee@xmail.com', 'Admin', <CreateIcon fontSize="small" />),
];

function UserManagement() {
  return (
    <div>
      <div className="my-2 ml-2">
        <div className="text-lg font-light flex items-center justify-between">
          <div>การจัดการผู้ใช้งาน</div>
        </div>
      </div>
      <div className="flex-1">
        <div className="px-2 py-4">
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">No.</TableCell>
                  <TableCell>E-mail</TableCell>
                  <TableCell>Role&nbsp;</TableCell>
                  <TableCell>Acction&nbsp;</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow
                    key={row.name}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell align="center">{row.no}</TableCell>
                    <TableCell>{row.email}</TableCell>
                    <TableCell>{row.role}</TableCell>
                    <TableCell>{row.acction}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}

export default UserManagement;
